module.exports = __webpack_public_path__ + "48ed63d22984d2359e4237317214ba43.svg";